import angular from 'angular';
import { AddressModule } from '@updater-components/address';
import { ChangeModule } from '@updater/angular-common';
import { ForwardMailFormComponent } from './form.component';
import { ForwardMailFormComponent as UdsForwardMailFormComponent } from '../../new-design/form/form.component';
import { NameSelectorModule } from '../../../../common/directives';
import '@updater-components/radio-group';

export const ForwardMailFormModule = angular
  .module('app.steps.forward-mail.form', [
    AddressModule.name,
    NameSelectorModule.name,
    ChangeModule.name,
  ])
  .component('updForwardMailForm', ForwardMailFormComponent)
  .component('udsForwardMailForm', UdsForwardMailFormComponent);
